import { apiController } from '@A/controllers/controller.api'

export type OrganizationModuleSummary = {
  common_id: string
  name: string
  parent_common_id: string | null
}

export type OrganizationModulesResponse = {
  modules: OrganizationModuleSummary[]
}

/**
 * Modules API controller
 *
 * Fetches the modules an organization has subscribed to. The mainapp uses this
 * to gate visibility of module-specific features (e.g. Nexus, Axios).
 */
export const apiModules = () => {
  const { controllerGet } = apiController('/access-control')

  const getOrganizationModules = async (organizationId: string): Promise<OrganizationModulesResponse> => {
    return await controllerGet<OrganizationModulesResponse>(`organizations/${organizationId}/modules`)
  }

  return {
    getOrganizationModules
  }
}
